import { useMutation } from '@tanstack/react-query';

import { Recipient } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { saveRecipient } from '../../requests/saveRecipient';

export const useSaveRecipient = () => {
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    Recipient | undefined,
    Error,
    Record<string, any>
  >({
    mutationFn: (data) =>
      saveRecipient(constructPatch, data).then((response) => response?.data),
  });

  return { saveRecipient: mutateAsync, ...rest };
};
